import React, { FunctionComponent } from "react";

const Info: FunctionComponent = () => <div />;

export default Info;
